export const WAEC_LITERATURE = [
  {
    q: "A soliloquy is when a character:",
    o: ["Speaks to another character", "Speaks their thoughts aloud alone on stage", "Writes a letter", "Sings a song"],
    a: 1,
    e: "A soliloquy is a dramatic device where a character speaks their inner thoughts aloud, usually alone on stage.",
    h: "Famous example: Hamlet's 'To be or not to be'.",
    yr: "2023",
  },
  {
    q: "The climax of a story is:",
    o: ["The beginning", "The turning point of highest tension", "The resolution", "The falling action"],
    a: 1,
    e: "The climax is the point of greatest tension in a narrative, usually where the central conflict reaches its peak.",
    h: "The most exciting moment.",
    yr: "2022",
  },
  {
    q: "A tragedy typically ends with:",
    o: ["A happy marriage", "The hero's downfall or death", "Comic resolution", "A journey"],
    a: 1,
    e: "Tragedy, as defined by Aristotle, involves the downfall of a protagonist, often ending in death.",
    h: "Opposite of comedy.",
    yr: "2023",
  },
  {
    q: "Which of these is an example of onomatopoeia?",
    o: ["The stars danced", "The buzzing of bees", "Life is a journey", "She is as brave as a lion"],
    a: 1,
    e: "Onomatopoeia is a word that phonetically imitates the sound it describes. 'Buzzing' sounds like the noise bees make.",
    h: "The word sounds like what it describes.",
    yr: "2021",
  },
  {
    q: "In poetry, a stanza is:",
    o: ["A single line", "A group of lines forming a unit", "A type of rhyme", "The title"],
    a: 1,
    e: "A stanza is a grouped set of lines within a poem, separated by blank lines. It is the poetic equivalent of a paragraph.",
    h: "Paragraph of a poem.",
    yr: "2022",
  },
];

export const WAEC_LITERATURE_LEARN = [
  {
    topic: "Prose Fiction",
    content: "Elements of a novel: Plot (sequence of events), Setting (time and place), Character (protagonist, antagonist, etc.), Theme (central idea), Point of view (first person, third person), Style and tone. Narrative techniques: flashback, foreshadowing, stream of consciousness.",
  },
  {
    topic: "Drama",
    content: "Dramatic elements: Acts and scenes, Stage directions, Dialogue, Soliloquy (speaking to self), Aside (speaking to audience). Types: Tragedy, Comedy, Tragicomedy, Melodrama. Greek drama introduced the chorus. Modern drama includes realism and absurdism.",
  },
  {
    topic: "Poetry",
    content: "Forms: Sonnet (14 lines), Haiku (5-7-5 syllables), Ode (praise poem), Elegy (lament), Ballad (narrative song). Devices: Rhyme (end sounds match), Rhythm (pattern of stressed syllables), Alliteration, Assonance, Imagery. Free verse has no fixed rhyme or metre.",
  },
  {
    topic: "Figures of Speech",
    content: "Simile: comparison using 'like' or 'as'. Metaphor: direct comparison. Personification: human qualities to non-humans. Hyperbole: exaggeration. Irony: saying opposite of meaning. Paradox: seemingly contradictory but true statement. Euphemism: mild substitute for harsh expression.",
  },
  {
    topic: "Themes in African Literature",
    content: "Common themes: colonialism and its aftermath, identity and belonging, tradition vs modernity, gender roles, corruption and governance, poverty and inequality, exile and displacement. Key authors: Chinua Achebe (Things Fall Apart), Wole Soyinka, Ngugi wa Thiong'o, Chimamanda Adichie.",
  },
];
